if (!customElements.get('in-view')) {
  class InView extends HTMLElement {
    constructor() {
      super();

      this.observer = null;
    }

    connectedCallback() {
      this.setThreshold();
      this.style.transitionDelay = this.dataset.animationDelay || '0s';

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this.observer.unobserve(this);
            }
          });
        },
        { threshold: this.threshold },
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    setThreshold() {
      const isMobile = !breakpointTablet.matches;

      if (this.dataset.thresholdMobile && isMobile) {
        console.log('test');
        this.threshold = +this.dataset.thresholdMobile;

        return;
      }

      this.threshold = +this.dataset.threshold || 0.15;
    }
  }

  customElements.define('in-view', InView);
}
